export default class ProductLikeExtension {

	constructor(naja) {
		this.naja = naja;
		naja.addEventListener('init', (event) => {
			this._init(document);
		});
		naja.addEventListener('success', (event) => {
			this._updateButtons(event);
		});
		naja.snippetHandler.addEventListener('afterUpdate', (event) => {
			this._init(event.snippet);
		});
	}

	/**
	 * @private
	 * @param {Node} block
	 */
	_init(block) {
		block.querySelectorAll('[data-product-like]').forEach((button) => {
			button.addEventListener('click', (event) => {
				event.preventDefault();
				const url = button.dataset.productLike;
				this.naja.makeRequest('GET', url);
			});
		});

		block.querySelectorAll('[data-product-like-link]').forEach((button) => {
			button.addEventListener('click', (event) => {
				event.preventDefault();
				document.location.href = button.dataset.productLikeLink;
			});
		});
	}

	/**
	 * @private
	 */
	_updateButtons(event) {
		for (let productId in event.response.productLikes) {
			const button = document.getElementById(`fn_product_like_${productId}`);
			if (button) {
				button.classList.toggle('active', event.response.productLikes[productId]);
			}
		}
	}

}